import React, { useRef } from 'react'
import { animate, motion } from 'framer-motion'
import Typewriter from 'typewriter-effect'
import { FiArrowDownRight, FiMail } from 'react-icons/fi'
import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai'

const Home = () => {
  const expCount = useRef(null)
  const projectCount = useRef(null)

  const animateExp = () => {
    animate(0, 2, {
      duration: 1.2,
      onUpdate: (v) => { if (expCount.current) expCount.current.textContent = v.toFixed() }
    })
  }

  const animateProjects = () => {
    animate(0, 10, {
      duration: 1.2,
      onUpdate: (v) => { if (projectCount.current) projectCount.current.textContent = v.toFixed() }
    })
  }

  const fadeUp = (delay = 0) => ({
    initial: { y: 40, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    transition: { duration: 0.7, delay, ease: [0.25, 0.46, 0.45, 0.94] }
  })

  return (
    <div id='home'>
      <div className="heroContent">
        <motion.p className="heroLabel" {...fadeUp(0.1)}>
          Full Stack Developer
        </motion.p>

        <motion.h1 className="heroName" {...fadeUp(0.2)}>
          Manav
          <br />
          <span className="gradient-text">Singh</span>
        </motion.h1>

        <motion.div className="heroTypewriter" {...fadeUp(0.35)}>
          <Typewriter
            options={{
              strings: ['I build scalable web apps', 'I engineer cloud solutions', 'I integrate AI workflows'],
              autoStart: true,
              loop: true,
              cursor: '_',
              wrapperClassName: "typewriterpara",
            }}
          />
        </motion.div>

        <motion.p className="heroBio" {...fadeUp(0.45)}>
          2+ years crafting production-grade SaaS platforms, analytics dashboards,
          and cloud-native solutions with the MERN stack at Simplifys Digital.
        </motion.p>

        <motion.div className="heroCtas" {...fadeUp(0.55)}>
          <a href="https://mail.google.com/mail/?view=cm&fs=1&to=manav9330833@gmail.com" target="_blank" rel="noreferrer" className="heroCtaPrimary">
            <FiMail /> Get in Touch
          </a>
          <a href="#work" className="heroCtaSecondary">
            View Work <FiArrowDownRight />
          </a>
        </motion.div>

        <motion.div className="heroSocials" {...fadeUp(0.65)}>
          <a href="https://github.com/Manav188" target="_blank" rel="noreferrer"><AiFillGithub /></a>
          <a href="https://linkedin.com/in/" target="_blank" rel="noreferrer"><AiFillLinkedin /></a>
        </motion.div>
      </div>

      <motion.div className="heroStats" {...fadeUp(0.7)}>
        <div className="statCard">
          <h3><motion.span ref={expCount} whileInView={animateExp}>0</motion.span>+</h3>
          <p>Years<br />Experience</p>
        </div>
        <div className="statCard">
          <h3><motion.span ref={projectCount} whileInView={animateProjects}>0</motion.span>+</h3>
          <p>Projects<br />Delivered</p>
        </div>
        <div className="statCard statCardAccent">
          <h4>Motivated</h4>
          <p>Developer</p>
        </div>
      </motion.div>
    </div>
  )
}

export default Home